import React from 'react';
export function Footer() {
  return <footer className="bg-navy-deep px-3 py-3 text-center sm:px-6" data-id="element-67" data-mp="32wd2qgad7ltj">
      <p className="text-[0.64rem] font-semibold text-white/80 sm:text-[0.74rem]" data-id="element-68" data-mp="3gfiyquovsxjx">
        © 2026 SURGICAL INSTRUMENTS VISUAL ATLAS™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1 max-w-2xl text-[0.62rem] leading-[1.45] text-white/65 sm:text-[0.72rem]" data-id="element-69" data-mp="36pfutzg81z6t">
        SURGICAL INSTRUMENTS VISUAL ATLAS™ is an educational and professional reference resource. It
        does not replace accredited education, institution-specific training, clinical protocols,
        manufacturer instructions, applicable regulations, required qualifications, professional
        supervision, or qualified clinical judgment.
      </p>
      <p className="mt-1 text-[0.62rem] text-white/75 sm:text-[0.72rem]" data-id="element-70" data-mp="3qblwzpgm4c1l">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-71" data-mp="29y5l8cy0g70t">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-72" data-mp="3l9k6jf1oprec">
          Privacy Policy
        </a>{' '}
        •{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-73" data-mp="3gbqzkjsk4td0">
          Contact
        </a>
      </p>
      <p className="mt-0.5 text-[0.62rem] text-white/75 sm:text-[0.72rem]" data-id="element-74" data-mp="3q8wr1t532mdr">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-75" data-mp="82qsbsqetttq">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}